export default "<div ng-class=\"{ 'has-translations': vm.attachment.is_translated }\" class=\"prizm-doc-viewer\"></div> ";